import {
  DoubleSide,
  MeshStandardMaterial,
  type MeshStandardMaterialParameters,
} from "three";

// Aluminium (profiles / angle sections): smoother and more reflective than the
// matte sheet metal used for corners and other parts, to increase visual
// contrast between part types.
// Single source of truth for both the raw material and the JSX component.
export const ALUMINUM_MATERIAL_PARAMS: MeshStandardMaterialParameters = {
  color: "#f6f6f6",
  metalness: 0.9,
  roughness: 0.15,
  envMapIntensity: 0.9,
  side: DoubleSide,
};

export const getRawAluminumMaterial = () =>
  new MeshStandardMaterial(ALUMINUM_MATERIAL_PARAMS);

export const AluminumMaterial = () => (
  <meshStandardMaterial {...ALUMINUM_MATERIAL_PARAMS} />
);
